import {theme} from "../../../../utils";

export const sortVendorData = (data: any[]) => {
    if (data.length) {
        return data.sort((a, b) => {
            const vendorA = a?.title?.toUpperCase();
            const vendorB = b?.title?.toUpperCase();

            return vendorA.localeCompare(vendorB);
        })
    }
    return []
}

export const styles = {
    vendorCard: {
        backgroundColor: "#fff",
        border: "0.89px solid #CDCDCD",
        borderRadius: "8px",
        mt: "1rem",
        display: "flex",
        alignItems: "center",
        justifyContent: 'center',
        flex: 1,
        maxWidth: "340px"
    },
    rowAlignBtnWrapper: {
        color: "#000",
        width: "128px",
        height: "38.33px",
        textTransform: "capitalize",
        borderRadius: '8px'
    },
    descriptionBox: {
        backgroundColor: "#F8F8F8",
        px: "30px",
        pb: "27px",
        pt: "1rem",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
    },
    cardDescription: {
        ...theme.typography.poppinsBodyLight,
        py: "8px",
        maxWidth: "678px",
        color: "#2D2B2A",
        fontSize:"14px",
        lineHeight: "130%"
    }
}